<template>
  <div class="dev-overlay-tool-groups">
    <button
      v-for="toolGroup in store.toolsGroups"
      :key="toolGroup"
      type="button"
      :class="['dev-overlay-tool-group-link', { selected: store.currentToolsGroup === toolGroup }]"
      @click="store.currentToolsGroup = toolGroup"
    >
      {{ store.toolGroupsTitles[toolGroup] }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import useDevOverlayStore from '@/stores/devOverlay';

export default defineComponent({
  setup() {
    const store = useDevOverlayStore();
    return { store };
  },
});
</script>

<style scoped lang="scss">
.dev-overlay-tool-groups {
  display: flex;
  flex-direction: column;
}

.dev-overlay-tool-group-link {
  text-align: left;
  font-size: .85rem;
  font-weight: 600;
  letter-spacing: .05em;
  border: none;
  padding: .75rem 1.25rem;
  min-width: 200px;
  text-decoration: none;
  background-color: transparent;

  $scope: button-main;

  &:hover {
    background-color: var(--acerto-primary-color-light);
  }

  &:active {
    background-color: var(--acerto-primary-color-dark);
  }

  &.selected {
    background-color: var(--acerto-primary-color);
  }
}
</style>
